export type StateKey = "新进展" | "补充" | "反转" | "辟谣" | "存档";

export interface TimelineItem {
  id: string;
  time: string;
  category: string;
  state: StateKey;
  subject: string;
  brief: string;
  refs: string;
}

export const timelineCategories = ["全部", "人物线", "商业线", "作品线", "实锤速递"];

export const timelineItems: TimelineItem[] = [
  {
    id: "t1",
    time: "刚刚",
    category: "实锤速递",
    state: "新进展",
    subject: "带货头部主播·选品翻车复盘",
    brief: "九色黑料爆料频道凌晨上线三段关联录音，时间线完整度拉到第七天，主播方暂未回应，评论区持续发酵。",
    refs: "来源：当事人直播切片 3 段 · 关联线索 11 条",
  },
  {
    id: "t2",
    time: "18 分钟前",
    category: "人物线",
    state: "反转",
    subject: "M姓艺人·旧照考古",
    brief: "九色黑料新进展：有网友挖出更早的原始底图，与此前流传的截图细节对不上，剧情出现明显反转倾向。",
    refs: "来源：公开图库 · 原始时间戳已标注",
  },
  {
    id: "t3",
    time: "42 分钟前",
    category: "商业线",
    state: "补充",
    subject: "某MCN机构·股权穿透新枝",
    brief: "关联企业工商信息再添两条，此前被质疑的空壳链条出现新节点，追更页已同步梳理为可视化脉络。",
    refs: "来源：工商快照 · 变更记录 5 条",
  },
  {
    id: "t4",
    time: "1 小时前",
    category: "作品线",
    state: "辟谣",
    subject: "热播剧番外·片酬传闻",
    brief: "剧组方放出盖章说明，称网传数字不实，九色黑料追踪小组把各方口径并排列出，供吃瓜网友自行对照。",
    refs: "来源：剧组官方说明 1 份",
  },
  {
    id: "t5",
    time: "2 小时前",
    category: "人物线",
    state: "新进展",
    subject: "退圈主播·复出预告",
    brief: "沉寂三个月后突然营业，账号只发了一条文案，评论区猜梗热度冲高，是否联动此前欠薪线存疑。",
    refs: "来源：账号主页 · 弹幕截图 24 张",
  },
  {
    id: "t6",
    time: "3 小时前",
    category: "商业线",
    state: "补充",
    subject: "明星餐饮·加盟口碑争议",
    brief: "九色黑料新进展新增加盟商亲历帖，涉及保证金退回流程，事件标签从「商誉」扩到「合同」。",
    refs: "来源：加盟社区帖子 2 篇",
  },
  {
    id: "t7",
    time: "5 小时前",
    category: "实锤速递",
    state: "存档",
    subject: "某选秀后援会·账目公示",
    brief: "账目明细已公开并归档，此前的众筹去向疑问告一段落，事件转入九色黑料追踪的存档库供随时复查。",
    refs: "来源：后援会公示附件",
  },
  {
    id: "t8",
    time: "6 小时前",
    category: "人物线",
    state: "补充",
    subject: "L姓主理人·公开信全文",
    brief: "公开信全文已逐段标注时间点，与早前爆料出入处高亮标出，想看九色黑料最新变化的瓜友可直接跳转对照。",
    refs: "来源：公开信全文 · 对照批注 19 处",
  },
  {
    id: "t9",
    time: "8 小时前",
    category: "作品线",
    state: "新进展",
    subject: "综艺剪辑·疑似口型争议",
    brief: "多段同机位侧拍流出，与正片台词存在偏差，弹幕量一夜翻倍，事件持续更新中。",
    refs: "来源：现场侧拍 · 对比视频 3 条",
  },
  {
    id: "t10",
    time: "11 小时前",
    category: "商业线",
    state: "存档",
    subject: "二手平台·价格异动记录",
    brief: "某周边价格异动已按小时取样归档，作为后续是否炒作的重要参照，追更面板内可查完整曲线。",
    refs: "来源：价格采样 48 个节点",
  },
];

export const archiveItems: TimelineItem[] = [
  {
    id: "a1",
    time: "09-05",
    category: "实锤速递",
    state: "新进展",
    subject: "周榜复盘：本周热度前三名的九色黑料追踪主线",
    brief: "",
    refs: "",
  },
  {
    id: "a2",
    time: "09-05",
    category: "人物线",
    state: "补充",
    subject: "素人爆料后续：当事人连发三条回应，口径前后有出入",
    brief: "",
    refs: "",
  },
  {
    id: "a3",
    time: "09-04",
    category: "商业线",
    state: "辟谣",
    subject: "机构声明盖章，流传版本被证伪，吃瓜方向已重置",
    brief: "",
    refs: "",
  },
  {
    id: "a4",
    time: "09-04",
    category: "作品线",
    state: "存档",
    subject: "定档传闻尘埃落定，官方海报时间线归入存档库",
    brief: "",
    refs: "",
  },
  {
    id: "a5",
    time: "09-03",
    category: "人物线",
    state: "反转",
    subject: "旧账重提：聊天记录时间戳成关键，出现反向解读",
    brief: "",
    refs: "",
  },
  {
    id: "a6",
    time: "09-02",
    category: "实锤速递",
    state: "新进展",
    subject: "多平台同天热搜，九色黑料新进展首页已即时同步",
    brief: "",
    refs: "",
  },
  {
    id: "a7",
    time: "09-01",
    category: "商业线",
    state: "存档",
    subject: "商标争议尘埃落定，判决书要点整理完毕",
    brief: "",
    refs: "",
  },
  {
    id: "a8",
    time: "08-31",
    category: "人物线",
    state: "补充",
    subject: "旧采访片段被考古，结合时间线再添两条旁证",
    brief: "",
    refs: "",
  },
  {
    id: "a9",
    time: "08-30",
    category: "作品线",
    state: "存档",
    subject: "片尾名单风波收尾，涉事方已作出书面说明",
    brief: "",
    refs: "",
  },
  {
    id: "a10",
    time: "08-29",
    category: "实锤速递",
    state: "新进展",
    subject: "直播连麦意外触发，围观人数刷新当周纪录",
    brief: "",
    refs: "",
  },
];

export interface TrackerStory {
  id: string;
  code: string;
  subject: string;
  category: string;
  followers: string;
  progress: number;
  heat: number;
  state: StateKey;
  brief: string;
  tags: string[];
  updated: string;
}

export const trackerStories: TrackerStory[] = [
  {
    id: "s1",
    code: "No.0421",
    subject: "带货头部主播·选品翻车",
    category: "直播·电商",
    followers: "12.6w",
    progress: 72,
    heat: 98,
    state: "新进展",
    brief: "录音、切片、售后退款口径三方并进，事件脉络已梳理到第七天。",
    tags: ["录音", "切片", "退款口径"],
    updated: "刚刚",
  },
  {
    id: "s2",
    code: "No.0398",
    subject: "某MCN机构·股权穿透",
    category: "商业·资本",
    followers: "8.1w",
    progress: 54,
    heat: 87,
    state: "补充",
    brief: "关联企业新增两个节点，空壳质疑逐步坐实，正在核对工商变更原始记录。",
    tags: ["股权", "工商", "空壳"],
    updated: "42 分钟前",
  },
  {
    id: "s3",
    code: "No.0377",
    subject: "M姓艺人·旧照考古",
    category: "人物·饭圈",
    followers: "20.3w",
    progress: 61,
    heat: 94,
    state: "反转",
    brief: "原始底图被发现，与流传版本存在细节出入，站队双方都开始摇摆。",
    tags: ["考古", "底图", "时间戳"],
    updated: "18 分钟前",
  },
  {
    id: "s4",
    code: "No.0366",
    subject: "明星餐饮·加盟口碑",
    category: "消费·商誉",
    followers: "4.9w",
    progress: 38,
    heat: 71,
    state: "补充",
    brief: "加盟商亲历帖陆续出现，话题从商誉评价延伸到合同细节比对。",
    tags: ["加盟", "保证金", "合同"],
    updated: "3 小时前",
  },
  {
    id: "s5",
    code: "No.0351",
    subject: "热播剧番外·片酬传闻",
    category: "影视·番外",
    followers: "9.4w",
    progress: 45,
    heat: 76,
    state: "辟谣",
    brief: "片方盖章回应不实，但各方口径并存，九色黑料追踪保留完整对照页。",
    tags: ["片酬", "盖章", "对照"],
    updated: "1 小时前",
  },
  {
    id: "s6",
    code: "No.0330",
    subject: "选秀后援会·账目公示",
    category: "饭圈·财务",
    followers: "15.8w",
    progress: 90,
    heat: 82,
    state: "存档",
    brief: "明细已公开归档，众筹去向疑问基本画句号，转存九色黑料追踪存档库。",
    tags: ["账目", "众筹", "归档"],
    updated: "5 小时前",
  },
];

export const channelRacks = [
  { key: "ch1", name: "人物线", icon: "ri-user-3-line", desc: "艺人·主播·主理人动态", count: 128 },
  { key: "ch2", name: "商业线", icon: "ri-briefcase-2-line", desc: "资本·合同·商誉纠纷", count: 96 },
  { key: "ch3", name: "作品线", icon: "ri-clapperboard-line", desc: "影视·综艺·番外争议", count: 74 },
  { key: "ch4", name: "实锤速递", icon: "ri-flag-2-line", desc: "高置信证据快讯集中地", count: 53 },
  { key: "ch5", name: "考古旧账", icon: "ri-time-line", desc: "旧帖时间线重建专题", count: 41 },
  { key: "ch6", name: "吃瓜社区", icon: "ri-group-2-line", desc: "围观讨论与意见对撞", count: 33 },
];

export const quickStats = [
  { label: "今日新增爆料", value: "37 条" },
  { label: "正在追踪事件", value: "21 件" },
  { label: "全网围观人数", value: "186w" },
  { label: "平均更新间隔", value: "8 分钟" },
];

export const faqItems = [
  {
    q: "九色黑料多久更新一次？",
    a: "首页的九色黑料新进展采用快讯式滚动更新，只要有新的爆料、回应或辟谣被核实，就会在时间线里即时插入，不必翻旧帖。",
  },
  {
    q: "「新进展」和「存档」有什么区别？",
    a: "还在发酵、有后续可追踪的归入最新进展快讯；已经收尾或证据链补全的事件会转入存档速查，方便你按日期回看完整脉络。",
  },
  {
    q: "追更看漏了，怎么回到之前的进度？",
    a: "每一则九色黑料爆料都会带上时间戳与关联线索编号，配合页面下方的存档速查，随时能把某个事件的时间线重新拉齐。",
  },
  {
    q: "追踪的置信度如何判断？",
    a: "每条快讯会标注来源类型（切片、录音、工商快照、盖章说明等），并在事件榜给出「进展度」。证据不足的线会标为补充/存疑，不会直接下结论。",
  },
  {
    q: "刷新就够了吗？还需要做别的吗？",
    a: "刷新即可看到九色黑料最新变化；若想不错过跨平台的同事件动态，可在下方下载追更入口，把不同来源聚合到一起。",
  },
];